import * as Yup from "yup";

import {
  charter724PassengerTypeItems,
  charter724GenderTypeItems,
  charter724NationalityCodeItems,
  charter724NationalityItems,
  createTransactionTypeItems,
  genderTypeItems,
  userRoleItems,
  flyOrderStatusItems,
  categoryItems,
  receptionOrderStatusItems,
  paymentTypeItems,
} from "../enum";

// User Name
const userNameRegex = /^[a-zA-Z0-9]+$/;

// Space
const spaceRegex = /^\S*$/;

// Phone Number
const phoneNumberRegex = /^09\d{9}$/;

export const isValidPhoneNumber = (phoneNumber) => {
  return phoneNumberRegex.test(phoneNumber);
};

// Email
const emailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const isValidEmail = (email) => {
  return emailRegex.test(email);
};

// Text
export const persianRegex = /^[\u0600-\u06FF\u200C\u200B\s]+$/;
export const englishRegex = /^[A-Za-z\s]+$/;

// Date
const dateRegex = /^(\d{4})-(\d{2})-(\d{2})$/;
const timeRegex = /^(\d{2}):(\d{2}):(\d{2})$/;
export const isDateBiggerThan = (firstDate, secondDate) => {
  if (secondDate) {
    const convertFirstDate = new Date(firstDate);
    const convertSecondDate = new Date(secondDate);

    return convertSecondDate.getTime() < convertFirstDate.getTime();
  } else {
    const dateNow = new Date();
    const convertFirstDate = new Date(firstDate);

    return dateNow.getTime() < convertFirstDate.getTime();
  }
};

//* Start Yup Validations

// Validation
const phoneNumber = Yup.string()
  .required("شماره موبایل الزامی است")
  .min(11, "شماره موبایل نمی تواند کمتر از 11 کاراکتر باشد")
  .max(11, "شماره موبایل نمی تواند بیشتر از 11 کاراکتر باشد")
  .matches(phoneNumberRegex, "شماره موبایل وارد شده معتبر نیست");
const password = Yup.string()
  .required("کلمه عبور الزامی است")
  .min(6, "کلمه عبور نمی تواند کمتر از 6 کاراکتر باشد")
  .max(255, "کلمه عبور نمی تواند بیشتر از 255 کاراکتر باشد");
const newPassword = Yup.string()
  .required("کلمه عبور جدید الزامی است")
  .min(6, "کلمه عبور جدید نمی تواند کمتر از 6 کاراکتر باشد")
  .max(255, "کلمه عبور جدید نمی تواند بیشتر از 255 کاراکتر باشد");
const confirmPassword = Yup.string()
  .required("تکرار کلمه عبور الزامی است")
  .oneOf(
    [Yup.ref("password"), null],
    "کلمه عبور و تکرار کلمه عبور یکسان نیستند"
  );
const firstName = Yup.string()
  .required("نام الزامی است")
  .max(255, "نام نمی تواند بیشتر از 255 کاراکتر باشد")
  .matches(persianRegex, "نام باید حروف فارسی باشد")
  .trim();
const lastName = Yup.string()
  .required("نام خانوادگی الزامی است")
  .max(255, "نام خانوادگی نمی تواند بیشتر از 255 کاراکتر باشد")
  .matches(persianRegex, "نام خانوادگی باید حروف فارسی باشد")
  .trim();
const firstNameLatin = Yup.string()
  .required("نام لاتین الزامی می باشد")
  .max(255, "نام لاتین نمی تواند بیشتر از 255 کاراکتر باشد")
  .matches(englishRegex, "نام لاتین باید حروف لاتین باشد");
const lastNameLatin = Yup.string()
  .required("نام خانوادگی لاتین الزامی می باشد")
  .max(255, "نام خانوادگی لاتین نمی تواند بیشتر از 255 کاراکتر باشد")
  .matches(englishRegex, "نام خانوادگی لاتین باید حروف لاتین باشد");
const birthDate = Yup.string().required("تاریخ تولد الزامی می باشد");
const gender = Yup.string()
  .required("جنسیت الزامی می باشد")
  .oneOf(genderTypeItems, "جنسیت مجاز نمی باشد");
const email = Yup.string()
  .required("پست الکترونیک الزامی است")
  .email("پست الکترونیک وارد شده معتبر نیست")
  .trim();
const nationalNumber = Yup.string()
  .required("کد ملی الزامی است")
  .min(10, "کدملی نمی تواند کمتر از 10 کاراکتر باشد")
  .max(10, "کدملی نمی تواند بیشتر از 10 کاراکتر باشد");
const avatar = Yup.string().max(
  255,
  "نام فایل تصویر پروفایل نمی تواند بیشتر از 255 کاراکتر باشد"
);
const code = Yup.string()
  .required("کد الزامی می باشد")
  .max(255, "کد نمی تواند بیشتر از 255 کاراکتر باشد");
const post = Yup.string()
  .required("سمت الزامی می باشد")
  .max(255, "سمت نمی تواند بیشتر از 255 کاراکتر باشد");
const hotelServices = Yup.array(
  Yup.object({
    value: Yup.string(),
    label: Yup.string(),
  })
).nullable();
const totalAmount = Yup.string().required("مبلغ کل الزامی است");
const role = Yup.string()
  .required("نقش الزامی است")
  .oneOf(userRoleItems, "نقش مجاز نیست");
const geoName = Yup.string()
  .required("نام الزامی است")
  .max(255, "نام نمی تواند بیشتر از 255 کاراکتر باشد")
  .trim();
const description = Yup.string().max(
  4096,
  "توضیحات نمی تواند بیشتر از 4096 کاراکتر باشد"
);
const reason = Yup.string().max(
  4096,
  "دلیل نمی تواند بیشتر از 4096 کاراکتر باشد"
);
const title = Yup.string()
  .required("عنوان الزامی است")
  .max(255, "عنوان نمی تواند بیشتر از 255 کاراکتر باشد");
const message = Yup.string()
  .required("متن پیام الزامی است")
  .max(4096, "متن پیام نمی تواند بیشتر از 4096 کاراکتر باشد");
const user = Yup.string().required("کاربر الزامی است");
const amount = Yup.string().required("مبلغ الزامی است");
const from = Yup.string()
  .required("تاریخ شروع الزامی است")
  .matches(dateRegex, 'تاریخ شروع باید به فرمت "YYYY-MM-DD" باشد');
const to = Yup.string()
  .required("تاریخ پایان الزامی است")
  .matches(dateRegex, 'تاریخ پایان باید به فرمت "YYYY-MM-DD" باشد');
const travelFrom = Yup.string().required("تاریخ شروع الزامی است");
const travelTo = Yup.string().required("تاریخ پایان الزامی است");
const transactionAmount = Yup.object({
  travel: Yup.string().required("مبلغ سفر و گردشگری الزامی است"),
  service: Yup.string().required("مبلغ خدمات کاربردی روزانه الزامی است"),
  household: Yup.string().required("مبلغ خرید لوازم منزل الزامی است"),
  sustenance: Yup.string().required("مبلغ خرید ارزاق الزامی است"),
  entertainment: Yup.string().required("مبلغ ورزش، تفریح و سرگرمی الزامی است"),
  lifestyle: Yup.string().required("مبلغ سبک زندگی و خانواده الزامی است"),
  education: Yup.string().required("مبلغ آموزش و توانمندسازی الزامی است"),
  gift: Yup.string().required("مبلغ هدایای مناسبتی الزامی است"),
}).required("مبلغ الزامی است");
const transactionType = Yup.string()
  .required("نوع تراکنش الزامی است")
  .oneOf(createTransactionTypeItems, "نوع تراکنش مجاز نیست");
const snappTrip = Yup.object({
  discount: Yup.string().required("میزان تخفیف اسنپ تریپ الزامی است"),
  profitPercentage: Yup.string().required(
    "میزان درصد سود اسنپ تریپ الزامی است"
  ),
}).required("اطلاعات اسنپ تریپ الزامی است");
const paymentType = Yup.string()
  .required("نوع پرداخت الزامی است")
  .oneOf(paymentTypeItems, "نوع پرداخت مجاز نیست");
const price = Yup.string().required("قیمت الزامی است");
const charter724 = Yup.object({
  discount: Yup.string().required("میزان تخفیف چارتر 724 الزامی است"),
  profitPercentage: Yup.string().required(
    "میزان درصد سود چارتر 724 الزامی است"
  ),
}).required("اطلاعات چارتر 724 الزامی است");
const discount_code = Yup.string().nullable();
const special_requests = Yup.string().nullable();
const extra_beds = Yup.number().nullable();
const roomId = Yup.number().required("شناسه اتاق الزامی است");
const foreigner = Yup.boolean().required("نوع مهمان الزامی است");
const flyOrderStatus = Yup.string()
  .required("وضعیت سفارش پرواز الزامی است")
  .oneOf(
    [flyOrderStatusItems[5], flyOrderStatusItems[6]],
    "وضعیت سفارش پرواز مجاز نیست"
  );
const receptionOrderStatus = Yup.string()
  .required("وضعیت سفارش پذیرنده الزامی است")
  .oneOf(receptionOrderStatusItems, "وضعیت سفارش پذیرنده مجاز نیست");
const permissions = Yup.string()
  .required("سطح دسترسی الزامی است")
  .min(6, "سطح دسترسی نمی تواند کمتر از 6 کاراکتر باشد")
  .max(6, "سطح دسترسی نمی تواند بیشتر از 6 کاراکتر باشد");
const guests = Yup.array(
  Yup.object({
    first_name: Yup.string().nullable(),
    foreigner,
    last_name: Yup.string().nullable(),
  })
);
const travelGuests = Yup.array(
  Yup.object({
    first_name: Yup.string().required("نام مسافر الزامی است"),
    last_name: Yup.string().required("نام خانوادگی مسافر الزامی است"),
  }).required("مسافر الزامی است")
)
  .min(1, "حداقل یک مسافر الزامی است")
  .required("مسافر الزامی است");
const rooms = Yup.array(
  Yup.object({
    extra_beds,
    guests,
    id: roomId,
  })
).min(1, "انتخاب حداقل یک اتاق الزامی است");
const otp = Yup.string()
  .required("کداعتبارسنجی الزامی است")
  .min(5, "کداعتبارسنجی نمی تواند کمتر از 5 کاراکتر باشد")
  .max(5, "کداعتبارسنجی نمی تواند بیشتر از 5 کاراکتر باشد");
const orderTimeOut = Yup.string().required("زمان اتمام معامله الزامی است");
const captchcode = Yup.string().required("کد کپچا الزامی است");
const mobile = phoneNumber;
const passengers = Yup.array(
  Yup.object({
    passengerType: Yup.string()
      .required("نوع مسافر الزامی است")
      .oneOf(charter724PassengerTypeItems, "نوع مسافر مجاز نیست"),
    // fnamefa: firstName,
    // lnamefa: lastName,
    fnameen: firstNameLatin,
    lnameen: lastNameLatin,
    gender: Yup.number()
      .required("جنسیت الزامی است")
      .oneOf(charter724GenderTypeItems, "جنسیت مجاز نیست"),
    nationality: Yup.number()
      .required("ملیت الزامی است")
      .oneOf(charter724NationalityItems, "ملیت مجاز نیست"),
    passengerCode: Yup.string().required("کد مسافر الزامی است"),
    nationalitycode: Yup.string()
      .required("کد ملیت الزامی است")
      .oneOf(charter724NationalityCodeItems, "کد ملیت مجاز نیست"),
    // expdate: Yup.string()
    //   .required("تاریخ انقضا پاسپورت الزامی است")
    //   .matches(dateRegex, 'تاریخ انقضا پاسپورت باید به فرمت "YYYY-MM-DD" باشد'),
    // birthday: Yup.string()
    //   .required("تاریخ تولد الزامی است")
    //   .matches(dateRegex, 'تاریخ تولد باید به فرمت "YYYY-MM-DD" باشد'),
    price,
  }).required("مسافر الزامی است")
).min(1, "حداقل یک مسافر الزامی است");
const ticketLink = Yup.string().nullable();
const picture = Yup.string().max(
  255,
  "نام فایل تصویر نمی تواند بیشتر از 255 کاراکتر باشد"
);
const category = Yup.string().required("دسته بندی الزامی است");
const features = Yup.array(Yup.string().required("ویژگی الزامی است"));
const pictures = Yup.array(
  Yup.string()
    .required("تصویر الزامی است")
    .max(255, "نام فایل تصویر نمی تواند بیشتر از 255 کاراکتر باشد")
)
  .min(1, "حداقل یک تصویر الزامی است")
  .required("تصاویر الزامی است");
const address = Yup.string()
  .required("آدرس الزامی است")
  .max(255, "آدرس نمی تواند بیشتر از 255 کاراکتر باشد");
const receptionType = Yup.string()
  .required("نوع پذیرنده الزامی است")
  .oneOf(categoryItems, "نوع پذیرنده مجاز نیست");
const latitude = Yup.string().required("عرض جغرافیایی الزامی است");
const longitude = Yup.string().required("طول جغرافیایی الزامی است");
const geo = Yup.object({
  latitude,
  longitude,
}).required("مختصات جغرافیایی الزامی است");
const _id = Yup.string().required("شناسه الزامی است");
const verifyCode = Yup.string().required("کد تایید الزامی است");
const count = Yup.string().required("تعداد الزامی است");
const products = Yup.array(
  Yup.object({
    _id,
    title,
    price,
    count,
  }).required("محصول الزامی است")
)
  .required("محصولات الزامی است")
  .min(1, "حداقل یک محصول الزامی است");
const isAgentConfirm = Yup.boolean().required(
  "تایید سفارش توسط نماینده الزامی است"
);
const isCheckNumberOfCovered = Yup.boolean().required(
  "بررسی تعداد افراد تحت پوشش الزامی است"
);
const isAddedValue = Yup.boolean().required("ارزش افزوده الزامی است");

// Login User
export const loginUserValidation = Yup.object({
  phoneNumber,
  password,
});

// Create User
export const createUserValidation = Yup.object({
  firstName,
  lastName,
  email,
  nationalNumber,
  phoneNumber,
  password,
  confirmPassword,
});

// Forgot Password
export const forgotPasswordValidation = Yup.object({
  nationalNumber,
  phoneNumber,
});

// Edit User
export const editUserValidation = Yup.object({
  avatar: avatar.nullable(),
  code,
  birthDate,
  post,
  firstName,
  lastName,
  phoneNumber,
  email,
});

// Change Password
export const changePasswordValidation = Yup.object({
  password,
  newPassword,
  confirmPassword: Yup.string()
    .required("تکرار کلمه عبور جدید الزامی است")
    .oneOf(
      [Yup.ref("newPassword"), null],
      "کلمه عبور جدید و تکرار کلمه عبور جدید یکسان نیستند"
    ),
});

// Create User For Admin
export const createUserForAdminValidation = Yup.object().shape({
  avatar: avatar.nullable(),
  code,
  birthDate,
  post,
  firstName,
  lastName,
  email,
  nationalNumber,
  permissions,
  phoneNumber,
  password,
  confirmPassword,
});

// Edit User For Admin
export const editUserForAdminValidation = Yup.object().shape({
  avatar: avatar.nullable(),
  code,
  birthDate,
  post,
  firstName,
  lastName,
  email,
  permissions,
  nationalNumber,
  phoneNumber,
});

// Change User Password
export const changeUserPasswordValidation = Yup.object().shape({
  password,
  confirmPassword,
});

// Create Geo
export const createGeoValidation = Yup.object({
  name: geoName,
  provinceId: Yup.string().nullable(),
});

// Create Ticket
export const createTicketValidation = Yup.object().shape({
  title,
  message,
});

// Create Ticket For Admin
export const createTicketForAdminValidation = Yup.object().shape({
  user,
  title,
  message,
});

// Create Transaction For Admin
export const createTransactionForAdminValidation = Yup.object().shape({
  amount: transactionAmount,
  description,
  type: transactionType,
});

// Create Passenger
export const createPassengerValidation = Yup.object().shape({
  firstName,
  lastName,
  firstNameLatin,
  lastNameLatin,
  birthDate,
  gender,
  nationalNumber,
  phoneNumber,
});

// Create Transaction For Agent
export const createTransferTransactionForAgentValidation = Yup.object().shape({
  amount: transactionAmount,
  description,
});

// Create Books
export const createBooksValidation = Yup.object().shape({
  services: hotelServices,
  discount_code,
  rooms,
  special_requests,
});

// Edit Web Service Profit
export const editWebServiceProfitValidation = Yup.object().shape({
  snappTrip,
  charter724,
});

// Send Phone Number OTP
export const sendPhoneNumberOTPValidation = Yup.object({
  phoneNumber,
});

// Verify Phone Number OTP
export const verifyPhoneNumberOTPValidation = Yup.object({
  phoneNumber,
  otp,
});

// Send Email OTP
export const sendEmailOTPValidation = Yup.object({
  email,
});

// Verify Email OTP
export const verifyEmailOTPValidation = Yup.object({
  email,
  otp,
});

// Edit Setting
export const editSettingValidation = Yup.object().shape({
  charter724: Yup.object().shape({
    orderTimeOut,
  }),
});

// Reservation
export const reservationCharter724Validation = Yup.object().shape({
  captchcode,
  mobile,
  email,
  passengers,
});

// Change Fly Order Status
export const changeFlyOrderStatusValidation = Yup.object().shape({
  description,
  status: flyOrderStatus,
  ticketLink,
});

// Create Category
export const createCategoryValidation = Yup.object().shape({
  picture: picture.nullable(),
  title,
  description,
});

// Create Product
export const createProductValidation = Yup.object().shape({
  category,
  picture: picture.nullable(),
  title,
  features,
  price,
  description,
});

// Create Reception Info
export const createReceptionInfoValidation = Yup.object().shape({
  avatar: avatar.required("تصویر پروفایل الزامی است"),
  pictures,
  features,
  title,
  address,
  type: receptionType,
  description,
  geo,
  isAgentConfirm,
  isCheckNumberOfCovered,
});

// Create Shop Info
export const createShopInfoValidation = Yup.object().shape({
  avatar: avatar.required("تصویر پروفایل الزامی است"),
  pictures,
  features,
  title,
  address,
  type: receptionType,
  description,
  geo,
});

// Create Reception Order
export const createReceptionOrderValidation = Yup.object().shape({
  products,
  description,
});

// Create Travel Reception Order
export const createTravelReceptionOrderValidation = Yup.object().shape({
  products,
  description,
  from: travelFrom,
  to: travelTo,
  guests: travelGuests,
});

// Change Reception Order Status
export const changeReceptionOrderStatusValidation = Yup.object().shape({
  status: receptionOrderStatus,
  reason,
});

// Check Qr Code
export const checkQrCodeValidation = Yup.object().shape({
  price,
  totalAmount,
  isAddedValue,
  paymentType,
  description,
});

// Verify Qr Code
export const verifyQrCodeValidation = Yup.object().shape({
  verifyCode,
});
